<template>
  <button
    class="group inline-flex shrink-0 content-center items-center px-4 h-8 text-black text-sm font-semibold hover:bg-app-green bg-white border border-solid border-app-green rounded-lg cursor-pointer transition duration-200"
  >
    {{ text }}
    <AtomIconX v-if="selected" class="ml-2 w-3 h-3 text-app-green group-hover:text-black transition duration-200" />
  </button>
</template>

<script setup lang="ts">
interface Props {
  selected?: boolean
  text: string
}

const { selected = false, text } = defineProps<Props>()
</script>
